module.exports = __webpack_public_path__ + "img/health.b12070dc.jpg";